module.exports = __webpack_public_path__ + "img/product-hawk-u8-rgb.f7d07318.png";